export enum AccountLangPreference {
    ENGLISH = 'English',
    HEBREW = 'Hebrew',
}

export enum AccountCurrencyPreference {
    USD = 'USD',
    EUR = 'EUR',
}